export default "__VITE_ASSET__Bk5z$OWH__"